import React, { useEffect, useState } from 'react';
import GridProvider from './components/GridProvider';
import styles from './Documents.module.css';
import MuiDialog from '../../../../UI/MuiDialog/MuiDialog';
import useHttp from '../../../../../hooks/use-http';
import { urls } from './api/urls';

const Dokumenta = ({ formValue, openDialogDokumenta, metadata }) => {
  const [openDocument, setOpenDocument] = useState(false);
  const { getData } = useHttp('');
  const [openPath, setOpenPath] = useState(null);
  const [files, setFiles] = useState([]);
  const handleOpenFile = (item) => {
    setOpenPath(item.path);
    setOpenDocument(true);
  };
  const getDokument = async () => {
    console.log(urls.GET_DOKUMENT);
    const config = {
      method: 'POST',
      url: urls.GET_DOKUMENT,
      data: {
        idObjekta: formValue.id,
        objekat: metadata,
      },
    };
    console.log(config);
    const result = await getData(config);
    setFiles(result);
    console.log(result);
  };
  useEffect(() => {
    if (formValue.id && openDialogDokumenta) {
      console.log('Prikaz dokumenata', formValue.id);
      getDokument();
    }
  }, [formValue.id, openDialogDokumenta]);
  const downloadFile = async (fileUrl, fileName) => {
    const config = {
      method: 'POST',
      url: 'Dokumenta/konvertovanje_base64',
      data: { vrednost: fileUrl },
    };

    const response = await getData(config);

    const base64Data = response; // Pretpostavljam da response.data sadrži base64 string.

    // Konvertovanje base64 stringa u Blob objekt
    const byteCharacters = atob(base64Data);
    const byteNumbers = Array.from(byteCharacters, (char) =>
      char.charCodeAt(0),
    );
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });

    // Kreiranje URL-a za Blob objekt
    const blobUrl = URL.createObjectURL(blob);

    // Kreiranje i klikanje na link element za preuzimanje datoteke
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', fileName); // Postavite naziv datoteke
    document.body.appendChild(link);
    link.click();

    // Čišćenje URL-a i uklanjanje linka
    URL.revokeObjectURL(blobUrl);
    document.body.removeChild(link);
  };
  return (
    <>
      <GridProvider
        data={files}
        handleOpenFile={handleOpenFile}
        downloadFile={downloadFile}
      />
      ;
      <MuiDialog
        fullScreen
        // maxWidth="xl"
        open={openDocument}
        title="DOCUMENT"
        content={
          <iframe
            className={styles.fileContainer}
            src={openPath}
            title="File"
          />
        }
        handleClose={() => setOpenDocument(false)}
        deniedText="ZATVORI"
      />
    </>
  );
};

export default Dokumenta;
